var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M.32 15h3.2V5.107H.32V15zm1.6-11.17A1.922 1.922 0 0 1 0 1.915C0 .862.863 0 1.92 0s1.92.862 1.92 1.915A1.922 1.922 0 0 1 1.92 3.83zM12.8 15V8.744s-.352-1.309-1.6-1.244c-1.248.064-1.664.256-2.24.926V15h-3.2V5.107h3.2v1.468s1.056-2.043 3.2-1.883c1.984.128 3.456 1.34 3.775 3.925H16V15h-3.2z","fill":"#041E42","fillRule":"evenodd"}));
}

Linkedin.defaultProps = {"width":"16","height":"15"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
